const prefix = '@payuCard';

export const FETCH_LIST_REQUEST = `${prefix}/FETCH_LIST_REQUEST`;
export const FETCH_LIST_SUCCESS = `${prefix}/FETCH_LIST_SUCCESS`;
export const FETCH_LIST_FAILURE = `${prefix}/FETCH_LIST_FAILURE`;

export const SET_CARD_SELECT = `${prefix}/SET_CARD_SELECT`;
export const SET_PAYU_TOKEN = `${prefix}/SET_PAYU_TOKEN`;
export const RESET_PAYU_CARD_STATE = `${prefix}/RESET_PAYU_CARD_STATE`;
